import Swiper, {Navigation} from 'swiper/core'
import 'swiper/swiper-bundle.css'
import './Styles.scss'

Swiper.use([Navigation])

const productGallery = () => {
    const galleries = document.querySelectorAll('.product-gallery')

    galleries.forEach(gallery => {
        const slider = gallery.querySelector(' .swiper-container')
        const items = slider.querySelectorAll('.swiper-slide')
        const mainImage = gallery.querySelector('.product-gallery__main-image')

        const swiper = new Swiper(slider, {
            loop:          false, // (items.length > 3)
            slidesPerView: 3,
            spaceBetween:  10,
            navigation:    (items.length > 3)? ({
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }) : false
        })

        mainImage.addEventListener('click', (event) => {
            event.preventDefault()

            const mainThumbnail = gallery.querySelectorAll('.product-gallery__main-thumbnail')[0]

            mainThumbnail.click()
        })
    })
}

productGallery()